import React from "react";
import { useDispatch } from "react-redux";

import * as salesforceManagerActions from "../../../redux/SalesforceManagers/actions.js";

import PageBase from "../../../components/PageBase";
import SalesforceHeader from "./components/SalesforceHeader";
import IntegrationInfo from "./components/IntegrationInfo";

import salesforceLogoWhite from "../../../assets/integrations/salesforce-logo-white.png";

import "./salesforce-integration.scss";


const SalesforceIntegration = () => {
  const dispatch = useDispatch();
  const [salesforceManager, setSalesforceManager] = React.useState(null);

  const handleGetSalesforceManager = React.useCallback(() => {
    dispatch(salesforceManagerActions.getSalesforceManagers((data) => {
      setSalesforceManager(data?.[0] || null);
    }));
  }, [dispatch]);

  React.useEffect(() => {
    handleGetSalesforceManager();
  }, [handleGetSalesforceManager]);

  return (
    <PageBase title="Salesforce Integration" removeMargins>
      <div className="salesforce-integration-container">
        <SalesforceHeader />

        <IntegrationInfo />

        <div className="salesforce-integration-section">
          <div style={{ height: 2, width: 13, background: '#062229', marginTop: 12 }}></div>

          <div>
            <p style={{ fontWeight: 700, fontSize: 18, color: '#062229' }}>Salesforce Installer</p>
            <p style={{ color: '#5B828B', fontWeight: 700, fontSize: 14, marginBottom: 20 }}>Use the buttons below to install the Flow package in your Salesforce Sandbox or Production environment.</p>
            <p style={{ fontWeight: 400, fontSize: 14, color: '#5B828B', marginBottom: 0 }}>For detailed instructions and initial setup, please refer to the documentation section below.</p>
            <p style={{ fontWeight: 400, fontSize: 14, color: '#5B828B' }}>If you have any questions, feel free to contact us at info@flow.cloud</p>

            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <button 
                className="salesforce-install-button"
                onClick={() => {
                  window.open(salesforceManager?.sandbox_package_url || '', '_blank');
                }}
              >
                <img src={salesforceLogoWhite} alt="Salesforce White" />
                Install Package (Sandbox)
              </button>

              <button 
                className="salesforce-install-button" 
                onClick={() => {
                  window.open(salesforceManager?.package_url || '', '_blank');
                }}
              >
                <img src={salesforceLogoWhite} alt="Salesforce White" />
                Install Package (Production)
              </button>
            </div>
          </div>
        </div>
      </div>
    </PageBase>
  );
};

export default SalesforceIntegration;